export default {
  text: 'Câștigă <highlight>{{value}} puncte</highlight> cu această comandă',
};
